import React, { PureComponent, forwardRef } from 'react';

import { getCategoryDuration, getDurationAsString, getMinutesByString } from './Brikets/helpers';
import { withEventState } from 'src/ver2/pages/event/context';
import LittlePerson from 'src/ver2/components/person/little';
import Loader from 'src/ver2/components/loader';

import {
    closestCenter,
    DndContext,
    DragOverlay,
    useDraggable, useDroppable
} from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
    useSortable
} from '@dnd-kit/sortable';
import { sortBy, groupBy } from 'lodash';
import { Icon, Input, Button } from 'antd';

import './newStyle.css';

const roundNearest5 = (num) => Math.round(num / 5) * 5;

const Droppable = (props) => {
    const { setNodeRef, isOver } = useDroppable({
        id: props.id
    });

    const style = {};
    if (isOver) style.background = `green`;

    return (
        <div ref={setNodeRef} style={style}>
            {props.children}
        </div>
    );
}

const Draggable = (props) => {
    const { attributes, listeners, setNodeRef, transform } = useDraggable({
        id: props.id,
    });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : 'unset',
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {props.children}
        </div>
    );

    /* ... */
}

const Item = forwardRef(({ id, ...props }, ref) => {
    return (
        <div {...props} ref={ref}>
            {props.children}
        </div>
    )
});

function SortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: props.id });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : 'unset',
        transition
    };

    return (
        <Item ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {props.children}
        </Item>
    );
}

class EventShadulePlashka extends PureComponent {

    state = {
        inputTime: '14:00',
        activeId: null,
        categorysLoadind: false,
        catsDndType: 'switch', // 'link', //nodnd
        Categorys: null,
        mode: null // { type: 'persons', categoryId }, { type: 'time', categoryId }, { type: 'edit', categoryId }
    }

    setPersonMode = (categoryId = null) => this.setState({ mode: categoryId ? { type: 'persons', categoryId } : null })
    setTimeMode = (categoryId = null) => this.setState({ mode: categoryId ? { type: 'time', categoryId } : null })
    setEditMode = (categoryId = null) => this.setState({ mode: categoryId ? { type: 'edit', categoryId } : null })


    componentDidMount = () => {
        if (this.props.Categorys && this.props.Categorys.length) {
            this.initCategorys();
        }
    }
    componentDidUpdate = ({ Categorys }) => {
        if ((!Categorys || !Categorys.length) && (this.props.Categorys && this.props.Categorys.length)) {
            this.initCategorys();
        }

        if ((Categorys && this.props.Categorys) && (Categorys.length !== this.props.Categorys.length)) {
            this.initCategorys();
            this.setState({ categorysLoadind: false, mode: null });
        }

    }
    initCategorys = () => {
        const { Categorys } = this.props;
        this.setState({ Categorys })
    }

    saveAllCategorys = async (Categorys_) => {
        // const { Categorys } = this.state;
        const { Categorys: CategorysProps } = this.props;
        const Categorys = Categorys_ || this.state.Categorys;
        const { client, Championship, reloadCategorys } = this.props;

        this.setState({ categorysLoadind: true });

        for (let i = 0; i < Categorys.length; i++) {
            const { Id, IsPro, TimeStart } = Categorys[i];

            //   async updateCategory(competition_id, categoryId, elderCircle, timeStart = undefined, isCircled = undefined, sessionId = this.lastSessionId, FieldId = undefined, Name = undefined) {
            // NAME
            //  await client.updateCategory(competitionId, selectedCategory, null, undefined, undefined, client.lastSessionId, undefined, NameValue);

            const prevCat = CategorysProps.find(x => x.Id === Id);
            if (!(prevCat && prevCat.TimeStart === TimeStart)) {
                await client.updateCategory(Championship.Id, Id, null, TimeStart);
            }
            if (!(prevCat && prevCat.IsPro === IsPro)) {
                await client.updateCategoryIsPro(Championship.Id, Id, IsPro);
            }
        }

        reloadCategorys();
        this.setState({ categorysLoadind: false });
    }

    createBreak = async () => {
        // const { Name, CompetitionId, isCircled, FieldId, TimeStart, ElderCircle, AgeFrom, AgeTo, Gender, IsPro, IsGroup, MinutesPerCouple  } = req.query;
        const { client, Championship } = this.props;
        const { mode, Categorys } = this.state;

        const editMode = (mode && mode.type === 'edit') ? mode.categoryId : null;
        const targetCategory = Categorys.find(x => x.Id === editMode);

        if (!editMode || !targetCategory) return;

        const { TimeStart } = targetCategory;

        const Categorys_ = this.updateCategoryTime(editMode, undefined, 5);

        const data = {
            Name: 'ПЕРЕРЫВ',
            CompetitionId: Championship.Id,
            isCircled: 1,
            FieldId: 1,
            TimeStart,
            ElderCircle: 1,
            AgeFrom: 0,
            AgeTo: 0,
            Gender: 1,
            IsPro: 0,
            IsGroup: 0,
            MinutesPerCouple: 3
        }

        this.setState({ categorysLoadind: true, mode: null });
        await client.copyCategory(data);
        this.saveAllCategorys(Categorys_);
    }

    separate = async () => {
        const { client, Championship } = this.props;
        const { mode, Categorys } = this.state;

        const editMode = (mode && mode.type === 'edit') ? mode.categoryId : null;
        const targetCategory = Categorys.find(x => x.Id === editMode);

        const count = editMode ? this.getCountInCategory(editMode) : 0;

        const latters = ['Б', 'В', 'Г', 'Д'];

        let howManySeps = 0;
        if (count <= 8) howManySeps = 2;
        if (count >= 9) howManySeps = 3;
        if (count >= 13) howManySeps = 4;
        if (count >= 17) howManySeps = 5;

        this.setState({ categorysLoadind: true, mode: null });

        // не забываем изменить первичную
        await client.updateCategory(Championship.Id, editMode, null, undefined, undefined, client.lastSessionId, undefined, `${targetCategory.Name} гр.А`);

        for (let i = 0; i < (howManySeps - 1); i++) {
            const Name = `${targetCategory.Name} гр.${latters[i]}`;
            const data = { ...targetCategory, Name }

            await client.copyCategory(data);
        }

        this.saveAllCategorys();
    }

    deleteCategory = async () => {
        const { client, Championship, reloadCategorys } = this.props;
        const { mode, Categorys } = this.state;

        const editMode = (mode && mode.type === 'edit') ? mode.categoryId : null;
        const targetCategory = Categorys.find(x => x.Id === editMode);

        if (!editMode || !targetCategory) return;

        this.setState({ categorysLoadind: true, mode: null });
        await client.deleteCategory(Championship.Id, editMode);
        reloadCategorys();

    }

    autoCalcTime = async ({ SortedCategorys = undefined, allNew = undefined }) => {

        const { Categorys } = this.state;

        const { CategorysAsObjcet } = this.props;
        const { inputTime } = this.state;
        const minutesTime = getMinutesByString(inputTime);

        let Categorys_ = null;

        if (SortedCategorys) {
            Categorys_ = sortBy(SortedCategorys || Categorys, ['TimeStart']);
        }

        if (allNew) {
            Categorys_ = Object.values(CategorysAsObjcet);
        }

        // это калькуляционное число
        let lastTime = minutesTime;

        if (allNew) {
            for (let i = 0; i < Categorys_.length; i++) {
                const { Id, IsCircled, MinutesPerCouple } = Categorys_[i];
                const TimeStartValue = getDurationAsString(lastTime);
                // await client.updateCategory(Championship.Id, Id, null, TimeStartValue);
                this.updateCategoryTime(Id, TimeStartValue);

                const count = this.getCountInCategory(Id)
                const catDiration = getCategoryDuration({ count, IsCircled, MinutesPerCouple });
                lastTime += roundNearest5(catDiration);
            }
        } else {


            const CategoryGroups = groupBy(Categorys_, 'TimeStart');
            let firstTimeStart = Object.keys(CategoryGroups)[0];
            lastTime = getMinutesByString(firstTimeStart);

            const catValues = Object.values(CategoryGroups)

            for (let i = 0; i < catValues.length; i++) {
                const cats = catValues[i];
                let accumDuration = 0;
                const TimeStartValue = getDurationAsString(lastTime);
                for (let j = 0; j < cats.length; j++) {
                    const { Id, IsCircled, MinutesPerCouple } = cats[j];
                    this.updateCategoryTime(Id, TimeStartValue);

                    const count = this.getCountInCategory(Id);
                    const catDiration = getCategoryDuration({ count, IsCircled, MinutesPerCouple });
                    accumDuration += catDiration;
                }
                lastTime += roundNearest5(accumDuration);
            }
        }
    }

    render() {

        const { CatsLoading, CatsNotAllTimed, RightPart } = this;

        const { Event, upperStyle, Championship, client, reloadCompetitors, iAmAdmin } = this.props;
        const { Categorys } = this.state;
        const { width, height } = upperStyle;
        if (!iAmAdmin) {
            return <div>Нет прав на просмотр этой страницы</div>
        }

        if (!Event || !Categorys || !Championship) return <CatsLoading {...upperStyle} />


        return <div style={{ width, height }} className='admincategorys_main'>
            <DndContext
                onDragEnd={(e) => {

                    const { active, over } = e;
                    if (!active || !over) return;

                    client.updateCompetitor(Event.ChampionshipId, active.id, over.id, null).then(() => {
                        reloadCompetitors();
                    })
                }}
            >
                <CatsNotAllTimed {...upperStyle} />
                <RightPart />
            </DndContext>
        </div>
    }

    CatsLoading = ({ width, height }) => <div style={{ width, height }} className='admincategorys_main'>
        Загружается
    </div>

    RightPart = () => {

        const { autoCalcTime, saveAllCategorys } = this;
        const { inputTime, catsDndType, mode } = this.state;

        const personMode = (mode && mode.type === 'persons') ? mode.categoryId : null;
        const timeMode = (mode && mode.type === 'time') ? mode.categoryId : null;
        const editMode = (mode && mode.type === 'edit') ? mode.categoryId : null;
        // const noMode = !personMode && !timeMode;

        let competitors = [];
        if (personMode) {
            const { Competitors } = this.props;
            competitors = Competitors.filter(x => x.CategoryId === personMode);
        }

        const count = editMode ? this.getCountInCategory(editMode) : 0;

        return <div className='admincategorys_main_right'>
            <div className='admincategorys_main_right_block'>
                <span>
                    Автораспределение от
                </span>
                <Input value={inputTime} style={{ width: 100 }} onChange={(e) => { this.setState({ inputTime: e.target.value }) }} />
                <Button type="primary" onClick={() => autoCalcTime({ allNew: 1 })}> ОБНОВИТЬ </Button>
            </div>
            <div className='admincategorys_main_right_block'>
                <span>
                    Режим
                </span>
                <Button type={catsDndType === 'switch' ? "primary" : "default"} onClick={() => this.setState({ catsDndType: 'switch' })}> СМЕЩАТЬ </Button>
                <Button type={catsDndType === 'link' ? "primary" : "default"} onClick={() => this.setState({ catsDndType: 'link' })}> ОБЪЕДИНЯТЬ </Button>
                <Button type={catsDndType === 'nodnd' ? "primary" : "default"} onClick={() => this.setState({ catsDndType: 'nodnd' })}> БЕЗ ПЕРЕНОСА </Button>
            </div>
            {!!timeMode &&
                <div className='admincategorys_main_right_block'>
                    <span>
                        Время
                    </span>
                    <Button type="primary" onClick={() => this.updateCategoryTime(timeMode, null, -5)}> -5 МИН </Button>
                    <Button type="primary" onClick={() => this.updateCategoryTime(timeMode, null, 5)}> +5 МИН </Button>
                </div>
            }
            {!!personMode &&
                <div className='admincategorys_main_right_block'>
                    <span>
                        Участники
                    </span>
                    {competitors.map(({ UserId }) =>
                        <Draggable key={UserId} id={UserId}>
                            <LittlePerson height={30} mode={'categorys_admin'} personId={UserId} />
                        </Draggable>)}
                </div>
            }
            {!!editMode &&
                <div className='admincategorys_main_right_block'>
                    <span>
                        Редактировать
                    </span>
                    <Button type="primary" onClick={() => this.createBreak()}> ПЕРЕРЫВ ДО </Button>
                    <Button type="primary" disabled={count < 5} onClick={() => this.separate()}> РАЗБИТЬ </Button>
                    <Button type="danger" disabled={count > 0} onClick={() => this.deleteCategory()}> УДАЛИТЬ </Button>
                </div>
            }
            {(!timeMode && !personMode && !editMode) && <div className='admincategorys_main_right_block'>
                <Button type="primary" onClick={() => saveAllCategorys()}> СОХРАНИТЬ </Button>
            </div>}
        </div>
    }

    CatsNotAllTimed = () => {
        const { OneCategory } = this;
        const { Categorys } = this.state;
        const { activeId, categorysLoadind, catsDndType, mode } = this.state;

        const personMode = (mode && mode.type === 'persons') ? mode.categoryId : null;
        const timeMode = (mode && mode.type === 'time') ? mode.categoryId : null;
        const editMode = (mode && mode.type === 'edit') ? mode.categoryId : null;

        if (categorysLoadind) {
            return <div className='admincategorys_main_left'>
                <Loader text='перемещаю' />
            </div>
        }

        const findedCategory = activeId ? Categorys.find(x => x.Id === activeId) : null;
        const Categorys_ = sortBy(Categorys, ['TimeStart']);
        let even = 1;
        let BlockEndTimeAccum = 0;

        const noDnd = catsDndType === 'nodnd' || personMode || timeMode || editMode;
        // console.log ({ noDnd })

        const CATS = Categorys_.map((category, index) => {

            const { Id, TimeStart, IsCircled, MinutesPerCouple } = category;

            let isStarted = false;
            let isEnded = false;
            let BlockEndTime = null;

            const count = this.getCountInCategory(Id)
            const catDuration = getCategoryDuration({ count, IsCircled, MinutesPerCouple });
            BlockEndTimeAccum += catDuration;


            if (index === 0) { even = 1; isStarted = true; }
            else {
                if (category.TimeStart !== Categorys_[index - 1].TimeStart) {
                    even = even * -1;
                    isStarted = true;
                }
            }

            // если последняя
            if (index === (Categorys_.length - 1)) {
                isEnded = true;
            } else {
                if (category.TimeStart !== Categorys_[index + 1].TimeStart) {
                    isEnded = true;
                }
            }

            if (isEnded) {
                const minutesTime = getMinutesByString(TimeStart);
                BlockEndTime = getDurationAsString(minutesTime + BlockEndTimeAccum);
                BlockEndTimeAccum = 0;
            }

            const isActive = (activeId === Id);

            if (noDnd) return <Droppable id={category.Id}>
                <OneCategory {...{
                    category, even, isStarted, isEnded, isActive, BlockEndTime,
                    personMode, timeMode, editMode
                }} />
            </Droppable>

            return <SortableItem key={category.Id} id={category.Id} >
                <OneCategory {...{
                    category, even, isStarted, isEnded, isActive, BlockEndTime,
                    personMode, timeMode, editMode
                }} />
            </SortableItem>
        }
        )

        if (noDnd) {
            return <div className='admincategorys_main_left'>
                {CATS}
            </div>
        }

        return <div className='admincategorys_main_left'>
            <DndContext
                collisionDetection={closestCenter}
                onDragStart={this.handleDragStart}
                onDragEnd={this.handleDragEnd}
            >
                <SortableContext
                    items={Categorys_}
                    strategy={verticalListSortingStrategy}
                >
                    {CATS}
                </SortableContext>
                <DragOverlay>
                    {findedCategory ? <Item id={activeId}>
                        <OneCategory category={findedCategory} isOverlay={true} {...{ personMode, timeMode, editMode }} />
                    </Item> : null}
                </DragOverlay>
            </DndContext>
        </div>
    }

    // CatsNotAllTimed = () => {
    //     const { OneCategory } = this;
    //     const { Categorys } = this.props;
    //     return <div className='admincategorys_main_left'>
    //         {Categorys.map((category) => <OneCategory key={category.Id} category={category} />)}
    //     </div>
    // }

    OneCategory = ({ category, even, isStarted, isEnded, BlockEndTime, isOverlay, isActive, personMode, timeMode, editMode }) => {
        const { Name, Id, IsPro, IsCircled, MinutesPerCouple, TimeStart } = category;
        const { setPersonMode, setTimeMode, setEditMode, updateCategoryIsPro } = this;

        // const minutesTime = getMinutesByString(TimeStart);

        // const count = this.getCountInCategory(Id)
        // const catDuration = getCategoryDuration({ count, IsCircled, MinutesPerCouple });

        // const TimeEnd = getDurationAsString(minutesTime + catDuration);

        let className = 'admincategorys_onecategory_container';
        let text = ``;

        let timeStart = null;
        let tire = null;
        let timeEnd = null;

        if (!isOverlay) {
            if (even > 0) className += ' admincategorys_onecategory_container_even';
            if (isStarted) className += ' admincategorys_onecategory_container_started';
            if (isEnded) className += ' admincategorys_onecategory_container_ended';
            if (isActive) className += ' admincategorys_onecategory_container_active';

            if (isStarted) { timeStart = TimeStart };
            if (isEnded) { timeEnd = BlockEndTime };
        } else {
            const minutesTime = getMinutesByString(TimeStart);

            const count = this.getCountInCategory(Id)
            const catDuration = getCategoryDuration({ count, IsCircled, MinutesPerCouple });

            const TimeEnd = getDurationAsString(minutesTime + catDuration);
            timeStart = TimeStart;
            timeEnd = TimeEnd;
        }

        if (timeStart || timeEnd) tire = '-';

        const isBreak = Name === 'ПЕРЕРЫВ';

        const isProClassName = 'admincategorys_onecategory_container_ispro ' +
            (IsPro ? ' admincategorys_main_mode_selected' : '')

        const timeClassName = 'admincategorys_onecategory_container_time ' +
            (timeMode === Id ? ' admincategorys_main_mode_selected' : '')

        const personsClassName = 'admincategorys_onecategory_container_persons ' +
            (personMode === Id ? ' admincategorys_main_mode_selected' : '')

        const editClassName = 'admincategorys_onecategory_container_edit ' +
            (editMode === Id ? ' admincategorys_main_mode_selected' : '')

        if (isBreak) {
            className += ' admincategorys_onecategory_container_break'
            tire = null;
            timeEnd = null;
        }

        if (isBreak) return <div className={className}>
            <div className='admincategorys_onecategory_container_name'>
                {Name}
            </div>
            <div className={'admincategorys_onecategory_container_ispro'}/>

            <div className={'admincategorys_onecategory_container_persons'} />
            <div className={timeClassName} onClick={() => {
                setTimeMode((timeMode === Id) ? null : Id);
            }}>
                <span className='____start'>
                    {`${timeStart || ''}`}
                </span>
                <span className='____tire'>
                    {`${tire || ''}`}
                </span>
                <span className='____start'>
                    {`${timeEnd || ''}`}
                </span>
            </div>
            <div className={editClassName} onClick={() => {
                setEditMode((editMode === Id) ? null : Id);
            }}>
                <Icon type="edit" />
            </div>
        </div>

        return <div className={className}>
            <div className='admincategorys_onecategory_container_name'>
                {Name}
            </div>
            <div className={isProClassName} onClick={() => updateCategoryIsPro(Id)}>
                {'IsPro'}
            </div>
            <div className={personsClassName} onClick={() => {
                setPersonMode((personMode === Id) ? null : Id);
            }}>
                <Icon type="user" /> {this.getCountInCategory(category.Id)}
            </div>
            <div className={timeClassName} onClick={() => {
                setTimeMode((timeMode === Id) ? null : Id);
            }}>
                <span className='____start'>
                    {`${timeStart || ''}`}
                </span>
                <span className='____tire'>
                    {`${tire || ''}`}
                </span>
                <span className='____start'>
                    {`${timeEnd || ''}`}
                </span>
            </div>
            <div className={editClassName} onClick={() => {
                setEditMode((editMode === Id) ? null : Id);
            }}>
                <Icon type="edit" />
            </div>
        </div>
    }

    getCountInCategory = (id) => {
        const { competitorsCountInCategorys, isCompetitorsCountInCategorysReady } = this.props;
        if (!isCompetitorsCountInCategorysReady || !competitorsCountInCategorys || !competitorsCountInCategorys.length) return 0;
        const findedCount = competitorsCountInCategorys.find(x => x.CategoryId === id);
        if (findedCount) return findedCount.count;
        return 0;
    }

    handleDragStart = (event) => {
        const { active } = event;
        this.setState({ activeId: active.id })
    }

    handleDragEnd = (event) => {
        // const { CategorysAsObjcet, Categorys } = this.props;
        const { Categorys } = this.state;
        const { catsDndType } = this.state;
        const { active, over } = event;

        // console.log(active, over, CategorysAsObjcet);

        const { id: activeId } = active;
        const { id: overId } = over;
        const neededCat = Categorys.find(x => x.Id === overId);

        if (!neededCat) return this.setState({ activeId: null });

        const activeCategory = Categorys.find(x => x.Id === activeId);
        const overCategory = Categorys.find(x => x.Id === overId);


        if (activeId !== overId && activeCategory && overCategory) {
            const oldIndex = Categorys.indexOf(activeCategory);
            const newIndex = Categorys.indexOf(overCategory);

            let newCategorys = [...Categorys] //arrayMove(Categorys, oldIndex, newIndex);

            if (catsDndType === 'switch') {
                // если это смещение - мы ищем блок всех категорий, и все их смещаем на 1
                const newActiveTimeStart = newCategorys[newIndex].TimeStart;
                for (let i = 0; i < newCategorys.length; i++) {
                    if (newCategorys[i].TimeStart === newActiveTimeStart) {
                        const minutesTime = getMinutesByString(newActiveTimeStart);
                        const TimeStartValue = getDurationAsString(minutesTime + 1);
                        newCategorys[i].TimeStart = TimeStartValue;
                    }
                }
                newCategorys[oldIndex].TimeStart = newActiveTimeStart;
                this.autoCalcTime({ SortedCategorys: newCategorys });
            }

            if (catsDndType === 'link') {
                // если это соединение - мы ставим такой же timestart
                newCategorys[oldIndex].TimeStart = newCategorys[newIndex].TimeStart;
                this.autoCalcTime({ SortedCategorys: newCategorys });
            }

            // newCategorys[oldIndex].TimeStart = newCategorys[newIndex].TimeStart;
            // this.autoCalcTime(newCategorys);
            // return;
        }

        this.setState({ activeId: null })
    }

    updateCategoryTime = (categoryId, TimeStart, plusTime) => {
        const { Categorys } = this.state;
        let newCategorys = [...Categorys];

        let findedCategory = newCategorys.find(x => x.Id === categoryId);
        if (!findedCategory) return;
        const sliceTimeStart = findedCategory.TimeStart;

        for (let i = 0; i < newCategorys.length; i++) {

            if (plusTime !== undefined && newCategorys[i].TimeStart >= sliceTimeStart) {
                const minutesTime = getMinutesByString(newCategorys[i].TimeStart);
                newCategorys[i].TimeStart = getDurationAsString(minutesTime + plusTime);
                continue;
            }

            if (newCategorys[i].Id === categoryId) {
                newCategorys[i].TimeStart = TimeStart;
                break;
            }
        }

        this.setState({ Categorys: newCategorys });
        return newCategorys;
    }

    updateCategoryIsPro = (categoryId) => {
        const { Categorys } = this.state;
        let newCategorys = [...Categorys];

        for (let i = 0; i < newCategorys.length; i++) {
            if (newCategorys[i].Id === categoryId) {
                if (newCategorys[i].IsPro) {
                    newCategorys[i].IsPro = 0;
                } else {
                    newCategorys[i].IsPro = 1;
                }
                break;
            }
        }

        this.setState({ Categorys: newCategorys });
    }

}


export default withEventState(`
    Event, 
    Championship, 
    Categorys, 
    isCategorysReady,
    CategorysAsObjcet,
    reloadCategorys,
    reloadCompetitors,
    Results,
    isMobile,
    isCompetitorsCountInCategorysReady, 
    competitorsCountInCategorys, 
    client,
    iamuser,
    categorysInfo,
    isCategorysInfoReady,
    iAmAdmin,
    iAmCompetitor,
    redirect,
    showInfoModal,
    closeInfoModal,

    Competitors,
    isCompetitorsReady,
    
    groupsLoaded
    
    
    `)(EventShadulePlashka)